export default __webpack_public_path__ + "static/media/verifyback.7a224068.png";